import type { PropertyDTO } from "@zplanem/responses"
import { webPaths } from "@zplanem/web-paths"
import { Link } from "react-router-dom"
import { PropertyTypeBadge } from "./property-type-badge"

interface Props {
	property: PropertyDTO
}

export function PropertyCard({ property }: Props) {
	return (
		<Link
			to={webPaths.property(property.id)}
			className="block min-w-0 bg-muted/40 backdrop-blur-md rounded-lg border border-border p-5 hover:border-foreground/25 transition-colors"
		>
			<PropertyTypeBadge property={property} />
			<h3 className="text-lg font-bold text-foreground mt-1 truncate">
				{property.name}
			</h3>
			{(property.descriptionOneliner ??
			property.descriptionShort ??
			property.description) ? (
				<p className="mt-2 text-sm text-muted-foreground line-clamp-2">
					{property.descriptionOneliner ??
						property.descriptionShort ??
						property.description}
				</p>
			) : null}
		</Link>
	)
}
